import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getRangeIdFromCheckboxName } from '@/finsight/ui/components/strats/helpers';
import { fieldChange, getCheckboxChildren } from '@/Framework/UI/Organisms/Filters/Checkboxer/actions';
import { ICheckboxState } from '@/Framework/UI/Organisms/Filters/Checkboxer/types';
import { IStrats } from '@/finsight/infrastructure/repository/StratsRepository/types';

export const useStratsFilters = () => {
  const [rangeExcludedIds, setRangeExcludedIds] = useState<number[]>([]);
  const dispatch = useDispatch();

  const resetAllStratsFilters = () => setRangeExcludedIds([]);

  const filterStratsByRangeId = (rangeId: number) => {
    const excludedRanges = [...rangeExcludedIds];
    const rangeIndex = excludedRanges.indexOf(rangeId);

    if (rangeIndex !== -1) {
      excludedRanges.splice(rangeIndex, 1);
    } else {
      excludedRanges.push(rangeId);
    }

    setRangeExcludedIds(excludedRanges);
  };

  const toggleRanges = (isSelected: boolean, childrenRanges: number[]) => {
    let excludedRanges = [...rangeExcludedIds];

    if (!isSelected) {
      excludedRanges = [
        ...excludedRanges,
        ...childrenRanges.filter((range) => !excludedRanges.includes(range)),
      ];
    } else {
      excludedRanges = excludedRanges.filter((excludedItem) => !childrenRanges.includes(excludedItem));
    }

    setRangeExcludedIds(excludedRanges);
  };

  const filterStratsByRangeIdOnlyInner = (
    checkboxFieldName: string,
    parentCheckboxFieldName: string,
    siblingRanges: number[],
    groupedStrats: IStrats,
    checkboxes: ICheckboxState,
  ) => {
    const onlyRangeId = getRangeIdFromCheckboxName({ name: checkboxFieldName });
    setRangeExcludedIds(
      [
        ...siblingRanges.filter((range) => (range !== onlyRangeId)),
      ],
    );

    const children = getCheckboxChildren(checkboxes, parentCheckboxFieldName);

    Object.keys(checkboxes).forEach((key) => {
      if (key !== checkboxFieldName) {
        if (!checkboxes[key].checked && !children[key]) {
          dispatch(fieldChange({
            ...checkboxes[key],
            name: key,
            checked: true,
          }));
        }
        if (checkboxes[key].checked && children[key]) {
          dispatch(fieldChange({
            ...checkboxes[key],
            name: key,
            checked: false,
          }));
        }
      } else if (!checkboxes[checkboxFieldName].checked) {
        dispatch(fieldChange({
          ...checkboxes[checkboxFieldName],
          name: key,
          checked: true,
        }));
      }
    });
  };

  return {
    rangeExcludedIds,
    resetAllStratsFilters,
    filterStratsByRangeId,
    toggleRanges,
    filterStratsByRangeIdOnlyInner,
  };
};
